export interface ICustomerTypeItem {
    id: string;
    code: string;
    name: string;
}

export class CustomerTypeItem implements ICustomerTypeItem {
    id: string;
    code: string;
    name: string;

    constructor();
    constructor(obj: ICustomerTypeItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
    }
}